import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const MaterialInventoryReport = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportMaterial}>
					<h1 className="report-header">Material Inventory Report</h1>
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=f2f2cb6a-3204-4b86-9991-f41d117b1e41&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default MaterialInventoryReport;